export default __webpack_public_path__ + "static/logo-392f0162076a1cd7253dc137ae73322f.png";